export default __webpack_public_path__ + "static/media/spin-button.baf97965.svg";